import InputField from "../../components/ui/InputField";
import { useFormatTemplateStore } from "@/state/formatTemplateStore";
import { DragUploader } from "@/components/ui/DragUploader";
import Ring from "@/components/ui/Ring";

export default function CreateNewStep() {
  const formatTemplateData = useFormatTemplateStore((state) => state.formatTemplateData);
  const { updateFormatTemplateField, formatTemplateSidebar, setFormatTemplateSidebar } = useFormatTemplateStore();

  const handleFileChange = (file: File | null) => {
    localStorage.setItem("isFileChanged", "true");
    updateFormatTemplateField("file", file ? [file] : null);
    if (formatTemplateSidebar !== "create-new") {
      setFormatTemplateSidebar("create-new");
      localStorage.setItem("isUpdate", "true");
    }
  };
  return (
    <Ring className={"p-4 mt-10 flex flex-col gap-8"}>
      <p>
        Below you can create a new Format Template. Any content created on the AlphaScript Platform is designed in the
        Format template of your choosing.
      </p>
      <div className="flex flex-col gap-4">
        <InputField
          maxLength={50}
          title="Company Name:"
          text="Templates are usually designed for your own organization or for a client’s organizations. Specifying the company makes it easier to search for in the future."
          initialValue={formatTemplateData.companyName}
          onChange={(value: string) => {
            updateFormatTemplateField("companyName", value);
          }}
        />

        <InputField
          maxLength={50}
          title="Template Name:"
          text={
            <p>
              For a selected <b>company</b>, you may have multiple templates. Specify here the name of the template
              being used.{" "}
            </p>
          }
          initialValue={formatTemplateData.templateName}
          onChange={(value: string) => {
            updateFormatTemplateField("templateName", value);
          }}
        />

        <DragUploader
          labelText={"Template .potx File"}
          text={
            "Below you can create a new Format Template. Any content created on the AlphaScript Platform is designed in the Format template of your choosing."
          }
          onFileChange={handleFileChange}
          fileList={formatTemplateData.file}
        />
      </div>
    </Ring>
  );
}
